export const ColorsSet = {
  red: {
    color: "#FF3B30",
    borderColor: "#9B1D16",
  },
  orange: {
    color: "#FF9500",
    borderColor: "#B86000",
  },
  green: {
    color: "#34C759",
    borderColor: "#1F7A2D",
  },
  blue: {
    color: "#007AFF",
    borderColor: "#004A94",
  },
  purple: {
    color: "#AF52DE",
    borderColor: "#7F2BA6",
  },
  gray: {
    color: "#9ca3af",
    borderColor: "#5E6A73",
  },
};

export const colorYellow = {
  yellow: {
    color: "#FFCC00",
    borderColor: "#D59A00",
  }
};

export default ColorsSet;
